/**
 * @description
 * Simple component to perform redirection from
 * old failureName + startsAt route params to proper fault event id
 */
import { convertFaultEventNaturalKeyToId } from "diagnostics-domain/event";
import React from "react";
import { Navigate, useLocation, useParams } from "react-router";
import { useFaultEvents } from "../../../../../api/useFaultEvents";
import { indexBy } from "diagnostics-lib/iterable";
import { toBasenamePath } from "../../../../../router/helpers/navigation";
import { toPath } from "../../../../../router/helpers/path";

export function RedirectUsingFaultEventId() {
  const { projectId, failureName, startsAt, "*": subPath } = useParams();

  if (!projectId?.trim().length || !failureName?.trim().length || !startsAt?.trim().length) {
    return <Navigate to="/" />;
  }

  return (
    <Redirect
      projectId={projectId}
      failureName={failureName}
      startsAt={startsAt}
      subPath={subPath}
    />
  );
}

function Redirect({
  projectId,
  failureName,
  startsAt,
  subPath,
}: {
  projectId: string;
  failureName: string;
  startsAt: string;
  subPath: string | undefined;
}) {
  const { events: faultEvents } = useFaultEvents(projectId);
  const faultEventsById = indexBy(faultEvents, "id");
  const faultEventId = convertFaultEventNaturalKeyToId(projectId, failureName, new Date(startsAt));
  const location = useLocation();

  if (faultEventsById.has(faultEventId)) {
    const path = toBasenamePath(
      toPath("/projects/:projectId/fault-events/:faultEventId", { projectId, faultEventId }),
    );
    return (
      <Navigate
        to={{
          pathname: `${path}${subPath ? `/${subPath}` : ""}`,
          search: location.search,
          hash: location.hash,
        }}
      />
    );
  }

  return <Navigate to="/" />;
}
